import React from "react";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PaginatedResults, SearchInfo } from './common'
  
class AdvancedSearchResults extends React.Component{
    componentDidMount(){
    }

    handlePageChange() {
        const searchSectionSelector = '#searchsection';
        $('html, body').animate({ scrollTop: $(searchSectionSelector).offset().top }, 500);
        let items = $(`${searchSectionSelector} ul li a`);
        items && items.length > 0 && setTimeout(() => $(items[0]).focus(), 100);
    }

    render(){
        const { searchResult, searchFilters, isFetchingResults, errorMessage, noResultMessages } = this.props;

        return (
            <div aria-live="polite" id="advancedSearchResults">
                <SearchInfo searchFilters={searchFilters}></SearchInfo>
                {
                    errorMessage && <p>{errorMessage}</p>
                    || searchResult
                    && searchResult
                    && searchResult.Results
                    && searchResult.Results.length > 0
                    && <PaginatedResults Items={searchResult.Results}
                        resultsPerPage={20} handlePageChange={this.handlePageChange}></PaginatedResults>
                      || isFetchingResults && <p>Searching...</p>
                      || (
                        searchFilters
                        && searchFilters.searchEntityType === 'services'
                        && <p>{noResultMessages['service']}</p>
                        || searchFilters.searchEntityType === 'teams'
                        && <p>{noResultMessages['team']}</p>
                        || searchFilters.searchEntityType === 'specialists'
                        && <p>{noResultMessages['specialist']}</p>
                      )
                }
            </div>
      );
    }
}
const mapStateToProps = ({ advancedSearchResultsData, advancedSearchFiltersData }) => {
        return ({
            searchResult: advancedSearchResultsData.searchResult,
            searchFilters: advancedSearchResultsData.searchFilters,
            isFetchingResults: advancedSearchFiltersData.isFetchingResults,
            errorMessage: advancedSearchResultsData.error,
            noResultMessages: advancedSearchFiltersData.asFormInitialisationData.NoResultMessages,
        });
    }
  
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
        },
        dispatch
    )


export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdvancedSearchResults)